<template>
  <cms>
    <template #language-switcher v-if="$feature.enableLanguagePreference && $languagePref?.browserLanguage === 'es'">
      <div class="flex">
        <div class="w-1/2 <md:hidden">
          &nbsp;
        </div>
        <language-switcher class="my-4 w-full md:w-1/2" />
      </div>
    </template>
  </cms>
</template>

<script lang="ts" setup>
import type { PageContent } from '#types/page'
import cms from '#content/pages/[...slug].vue'

definePageMeta({
  validate({ path }) {
    return !/\.\w{2,5}$/.test(path)
  },
  async middleware({ params: { slug }, meta }) {
    const { getPage, getSeoMetadata } = useCms()
    const cmsPageState = useState<PageContent>('cmsPage')
    const pageError = useState<any>('cmsPageError')
    try {
      pageError.value = null
      const page = await getPage(slug)

      if (page) {
        const { metadata, link } = getSeoMetadata(page)
        useSeoMeta(metadata)
        useHead(() => ({ link }))
        cmsPageState.value = page
        meta.header = {
          transparent: page.overlayHeader,
          mode: page.headerStyle || 'light'
        }
      }
    }
    catch (error) {
      pageError.value = error
    }
  }
})
</script>
